import clsx from "clsx";
import { TONES, Tone } from "./tones";

export default function PulseDot({ tone, live = false, className }: { tone: Tone; live?: boolean; className?: string }) {
  return (
    <span className={clsx("relative inline-flex h-2.5 w-2.5 shrink-0", className)} aria-hidden>
      {live ? <span className={clsx("pulse-ring absolute inset-0 rounded-full", TONES[tone].text)} /> : null}
      <span className={clsx("relative h-2.5 w-2.5 rounded-full", TONES[tone].dot)} />
    </span>
  );
}
